// Elegant botanical olive-branch line illustration (inline SVG, stroke only).
export const OliveBranch = ({ className = "", style }) => (
  <svg
    className={className}
    style={style}
    viewBox="0 0 200 320"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.1"
    strokeLinecap="round"
    aria-hidden="true"
  >
    <path d="M100 315 C100 240 96 170 74 96 C60 50 44 26 22 8" />
    {[...Array(7)].map((_, i) => {
      const y = 60 + i * 34;
      return (
        <g key={i}>
          <path d={`M${96 - i} ${y} C${70 - i * 2} ${y - 6} ${52} ${y + 4} ${40} ${y + 22} C${58} ${y + 20} ${80 - i} ${y + 12} ${96 - i} ${y}`} />
          <path d={`M${98 - i} ${y + 16} C${122 + i * 2} ${y + 10} ${142} ${y + 20} ${156} ${y + 38} C${136} ${y + 36} ${114 - i} ${y + 28} ${98 - i} ${y + 16}`} />
        </g>
      );
    })}
    <ellipse cx="54" cy="120" rx="4.5" ry="7" transform="rotate(-30 54 120)" />
    <ellipse cx="132" cy="176" rx="4.5" ry="7" transform="rotate(28 132 176)" />
    <ellipse cx="70" cy="230" rx="4.5" ry="7" transform="rotate(-24 70 230)" />
  </svg>
);

export const Vine = ({ className = "", style }) => (
  <svg
    className={className}
    style={style}
    viewBox="0 0 320 120"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.1"
    strokeLinecap="round"
    aria-hidden="true"
  >
    <path d="M5 60 C80 20 240 100 315 60" />
    {[...Array(6)].map((_, i) => {
      const x = 45 + i * 45;
      const up = i % 2 === 0;
      const y = up ? 42 : 78;
      return (
        <path
          key={i}
          d={`M${x} ${up ? 48 : 72} C${x - 14} ${y - (up ? 18 : -18)} ${x - 4} ${y - (up ? 30 : -30)} ${x + 8} ${y - (up ? 34 : -34)} C${x + 6} ${y - (up ? 18 : -18)} ${x + 2} ${up ? 50 : 70} ${x} ${up ? 48 : 72}`}
        />
      );
    })}
  </svg>
);
